module.exports = __webpack_public_path__ + "static/media/TradeGothicLTStd-Cn18.ttf";